import { render, staticRenderFns } from "./DashboardSubpage.vue?vue&type=template&id=20c5bb4e&"
import script from "./DashboardSubpage.vue?vue&type=script&lang=js&"
export * from "./DashboardSubpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports